import React, { useEffect, useState } from "react";
import {
  Modal,
  message,
  Spin,
  Button,
  Space,
  Table,
  Tag,
  Typography,
  Card,
  Divider,
  Row,
  Col,
  Tabs,
  Avatar,
} from "antd";
import {
  CalendarOutlined,
  FileSearchOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import axios from "axios";
import {
  HEADERS_EXPORT_BEN,
  POST_JUDGE_BEEYPUP,
  POST_PREVIEW_BEEYPUP,
  POST_PREVIEW_JUDGE,
} from "../../../API/apiUrls";
import dayjs from "dayjs";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { BillCloseContno } from "../export/BillCloseContno";

const { Title, Text } = Typography;
const THEME = {
  primary: "#1a365d",
  secondary: "#2d4a6f",
  accent: "#e67e22",
  success: "#27ae60",
  warning: "#f39c12",
  danger: "#e74c3c",
  info: "#3498db",
  light: "#f8fafc",
  dark: "#1e293b",
  gradient: "linear-gradient(135deg, #1a365d 0%, #2d4a6f 100%)",
  cardShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
  borderRadius: "12px",
};

// ==================== UTILITIES ====================
const formatMoney = (value) => {
  if (!value && value !== 0) return "0";
  return Number(value).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// ── Main Component ────────────────────────────────────────────
const PreviewPayment = ({ open, close, dataDefault, dataContno }) => {
  const [uploading, setUploading] = useState(false);
  const [dateLoad, setDateLoad] = useState(dayjs());
  const [payment, setpayment] = useState([]);
  const [arothrData, setArothrData] = useState([]);

  useEffect(() => {
    if (dataDefault || dateLoad) {
      onQuery();
    }
  }, [dataDefault]);

  const onQuery = () => {
    console.log(dateLoad);

    if (!dateLoad) {
      message.warning("กรุณาเลือกวันที่ก่อนค้นหา");
      return;
    }
    let useApi;
    let payload;

    if (dataDefault?.flagLoanNew === 1 && dataDefault?.loanNew !== null) {
      useApi = POST_PREVIEW_BEEYPUP;
      payload = {
        NEW_CONTNO: dataDefault?.loanNew?.NEWCONTNO,
        loanNewId: dataDefault?.loanNew?.LoanNewId,
        DATETIME: dayjs(dateLoad).format("YYYY-MM-DDTHH:mm:ssZ"),
      };
    } else if (dataDefault?.flagLoanNew === 2) {
      useApi = POST_PREVIEW_JUDGE;
      payload = {
        NEW_CONTNO: dataDefault?.judge?.[0]?.newContno,
        DATETIME: dayjs(dateLoad).format("YYYY-MM-DDTHH:mm:ssZ"),
      };
    }
    if (dataDefault?.flagLoanNew === 2 && dataDefault?.loanJudge !== null) {
      useApi = POST_JUDGE_BEEYPUP;
      payload = {
        NEW_CONTNO: dataDefault?.loanJudge?.NEW_CONTNO,
        loanJudgeId: dataDefault?.loanJudge?.loanJudgeId,
        DATETIME: dayjs().format("YYYY-MM-DDTHH:mm:ssZ"),
      };
    }

    queryData(useApi, payload);
  };

  const queryData = async (useApi, payload) => {
    setUploading(true);
    try {
      const res = await axios.post(useApi, payload, {
        headers: HEADERS_EXPORT_BEN,
      });
      if (res.status === 200) {
        console.log(res);
        setpayment(res.data.data);
        setArothrData(res.data.arothr);
      }
    } catch (err) {
      message.error(
        err?.response?.status === 404 ? "ไม่พบข้อมูล" : "เกิดข้อผิดพลาด",
      );
    } finally {
      setUploading(false);
    }
  };

  const handleCancel = () => {
    close?.();
  };

  const handlePrintPDF = async () => {
    console.log("dataDefault ---->", dataDefault);
    console.log("payment ---->", payment);
    console.log("arothrData ---->", arothrData);
    console.log("dateLoad ---->", dateLoad);
    console.log("dataContno ---->", dataContno);

    await BillCloseContno(
      dataDefault,
      payment,
      arothrData,
      dateLoad,
      dataContno,
    );
  };

  const isInstallmentView =
    (dataDefault?.flagLoanNew === 1 && dataDefault?.loanNew !== null) ||
    (dataDefault?.flagLoanNew === 2 && dataDefault?.loanJudge !== null);

  const totalTonBalance = Number(dataDefault?.judge?.[0]?.TONBALANCE || 0);
  const totalBeeypup =
    payment?.reduce((sum, r) => sum + Number(r.BEEYPUP || 0), 0) || 0;
  const totalPayBeeypup =
    payment?.reduce((sum, r) => sum + Number(r.PAY_BEEYPUP || 0), 0) || 0;

  const summaryClosingBalance = () =>
    totalTonBalance + (totalBeeypup - totalPayBeeypup);

  return (
    <>
      <Modal
        title={`${dataDefault?.flagLoanNew === 1 && dataDefault?.loanNew !== null ? "ข้อมูลเบี้ยปรับ / ยอดปิด" : dataDefault?.flagLoanNew === 2 && dataDefault?.loanJudge !== null ? "ข้อมูลเบี้ยปรับ / ยอดปิด" : "ข้อมูลยอดจ่าย / ยอดปิด"} — ${dataDefault?.judge?.[0]?.newContno ?? ""}`}
        open={open}
        onCancel={handleCancel}
        width={1200}
        confirmLoading={uploading}
        footer={[
          <Button key="close" onClick={handleCancel} danger>
            ปิด
          </Button>,
          <Button
            key="print"
            onClick={handlePrintPDF}
            variant="outlined"
            color="blue"
          >
            พิมพ์
          </Button>,
        ]}
      >
        <Spin spinning={uploading} size="large" tip="กำลังอัปโหลด...">
          <Card
            style={{
              marginBottom: 8,
              borderRadius: 12,
              border: "1px solid #ffcb05",
              background: "#fffdf0",
            }}
          >
            <Row>
              <Col span={8}>
                <Tag
                  color={
                    (dataDefault?.flagLoanNew === 1 &&
                      dataDefault?.loanNew !== null) ||
                    (dataDefault?.flagLoanNew === 2 &&
                      dataDefault?.loanJudge !== null)
                      ? "green"
                      : "orange"
                  }
                >
                  {dataDefault?.flagLoanNew === 1 &&
                  dataDefault?.loanNew !== null
                    ? "ทำยอม"
                    : dataDefault?.flagLoanNew === 2 &&
                        dataDefault?.loanJudge !== null
                      ? "พิพากษา(ผ่อนชำระ)"
                      : "พิพากษา"}
                </Tag>
              </Col>
              <Col span={16} style={{ textAlign: "right" }}>
                <Space size={10}>
                  <ThaiDatePicker
                    value={dateLoad}
                    onChange={setDateLoad}
                    placeholder="กรุณาเลือกวันที่"
                    size="large"
                    style={{ width: "100%" }}
                    suffixIcon={<CalendarOutlined />}
                  />
                  <Button
                    color="blue"
                    variant="filled"
                    icon={<FileSearchOutlined />}
                    size="large"
                    onClick={() => onQuery()}
                    loading={uploading}
                    style={{ borderRadius: 8 }}
                  >
                    โหลดข้อมูล
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>
          {isInstallmentView && (
            <Card
              style={{
                marginBottom: 8,
                borderRadius: 12,
                overflow: "hidden",
                border: "none",
                boxShadow: THEME.cardShadow,
              }}
              styles={{ body: { padding: 0 } }}
            >
              <div
                style={{
                  background: THEME.gradient,
                  padding: "14px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 12,
                }}
              >
                <Space size={10} align="center">
                  <Tag
                    color="red"
                    style={{
                      fontSize: 13,
                      padding: "3px 12px",
                      borderRadius: 6,
                      margin: 0,
                    }}
                  >
                    ขอยอดปิดบัญชี
                  </Tag>
                </Space>
                <Tag
                  color="red"
                  style={{
                    fontSize: 13,
                    padding: "3px 12px",
                    borderRadius: 6,
                    margin: 0,
                  }}
                >
                  <CalendarOutlined style={{ marginRight: 6 }} />
                  ใช้ได้ถึงวันที่{" "}
                  <Text strong style={{ color: "red" }}>
                    {formatDate(dateLoad)}
                  </Text>
                </Tag>
              </div>

              <Row gutter={[12, 12]} style={{ padding: "18px 20px" }}>
                <Col xs={12} sm={6}>
                  <div
                    style={{
                      background: "#f9fafb",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "12px 14px",
                      height: "100%",
                    }}
                  >
                    <Text style={{ fontSize: 12, color: "#6b7280" }}>
                      เงินต้นคงเหลือ
                    </Text>
                    <br />
                    <Text strong style={{ fontSize: 18, color: THEME.dark }}>
                      {formatMoney(totalTonBalance)}
                    </Text>
                  </div>
                </Col>
                <Col xs={12} sm={6}>
                  <div
                    style={{
                      background: "#fef2f2",
                      border: "1px solid #fecaca",
                      borderRadius: 10,
                      padding: "12px 14px",
                      height: "100%",
                    }}
                  >
                    <Text style={{ fontSize: 12, color: "#6b7280" }}>
                      รวมเบี้ยปรับ
                    </Text>
                    <br />
                    <Text strong style={{ fontSize: 18, color: THEME.danger }}>
                      {formatMoney(totalBeeypup)}
                    </Text>
                  </div>
                </Col>
                <Col xs={12} sm={6}>
                  <div
                    style={{
                      background: "#f0fdf4",
                      border: "1px solid #dcfce7",
                      borderRadius: 10,
                      padding: "12px 14px",
                      height: "100%",
                    }}
                  >
                    <Text style={{ fontSize: 12, color: "#6b7280" }}>
                      ชำระเบี้ยปรับแล้ว
                    </Text>
                    <br />
                    <Text strong style={{ fontSize: 18, color: THEME.success }}>
                      {formatMoney(totalPayBeeypup)}
                    </Text>
                  </div>
                </Col>
                <Col xs={12} sm={6}>
                  <div
                    style={{
                      background: "#fffdf0",
                      border: "1px solid #ffcb05",
                      borderRadius: 10,
                      padding: "12px 14px",
                      height: "100%",
                    }}
                  >
                    <Text style={{ fontSize: 12, color: "#6b7280" }}>
                      ยอดปิดบัญชี
                    </Text>
                    <br />
                    <Text strong style={{ fontSize: 20, color: THEME.success }}>
                      {formatMoney(summaryClosingBalance())}
                    </Text>
                    <Text
                      style={{ fontSize: 12, marginLeft: 4, color: "#9ca3af" }}
                    >
                      บาท
                    </Text>
                  </div>
                </Col>
              </Row>
            </Card>
          )}
          {(dataDefault?.flagLoanNew === 1 && dataDefault?.loanNew !== null) ||
          (dataDefault?.flagLoanNew === 2 &&
            dataDefault?.loanJudge !== null) ? (
            <Table
              dataSource={payment}
              columns={[
                {
                  title: "งวดที่",
                  dataIndex: "NOPAY",
                  key: "NOPAY",
                  width: 40,
                  align: "center",
                },
                {
                  title: "วันที่ครบกำหนดคิดดอกเบี้ย",
                  dataIndex: "LASTDUEDT_SHOW",
                  key: "LASTDUEDT_SHOW",
                  width: 60,
                  align: "center",
                  render: (val) => formatDate(val),
                },
                {
                  title: "วันที่ชำระ",
                  dataIndex: "PAYDATE",
                  key: "PAYDATE",
                  width: 60,
                  align: "center",
                  render: (val, record) => formatDate(val),
                },
                {
                  title: "เกินกำหนด (วัน)",
                  dataIndex: "DELAYDAY",
                  key: "DELAYDAY",
                  width: 50,
                  align: "center",
                  render: (val, record) => (
                    <Tag color={val > 0 ? "red" : "green"}>{val}</Tag>
                  ),
                },

                {
                  title: "ค่าเบี้ยปรับ",
                  dataIndex: "BEEYPUP",
                  key: "BEEYPUP",
                  width: 60,
                  align: "right",
                  render: (val, record) => formatMoney(val),
                },

                {
                  title: "ชำระเบี้ยปรับ",
                  dataIndex: "PAY_BEEYPUP",
                  key: "PAY_BEEYPUP",
                  width: 60,
                  align: "right",
                  render: (val, record) => formatMoney(val),
                },
              ]}
              rowKey="id"
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
              }}
              size="small"
              rowClassName={(record) =>
                Number(record.PAYAMT) > 0 ? "row-paid" : ""
              }
              summary={() => {
                const totalPaid = payment?.reduce(
                  (sum, r) => sum + Number(r.PAY_BEEYPUP || 0),
                  0,
                );
                const totalBeeypup = payment?.reduce(
                  (sum, r) => sum + Number(r.BEEYPUP || 0),
                  0,
                );

                return (
                  <Table.Summary.Row style={{ background: THEME.light }}>
                    <Table.Summary.Cell colSpan={4} align="right">
                      <Text strong>รวม</Text>
                    </Table.Summary.Cell>

                    <Table.Summary.Cell align="right">
                      <Text
                        strong
                        style={{
                          color: totalPaid > 0 ? THEME.success : THEME.danger,
                          fontSize: 14,
                        }}
                      >
                        {formatMoney(totalBeeypup)}
                      </Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">
                      <Text
                        strong
                        style={{
                          color: totalPaid > 0 ? THEME.success : THEME.danger,
                          fontSize: 14,
                        }}
                      >
                        {formatMoney(totalPaid)}
                      </Text>
                    </Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          ) : (
            <Tabs
              type="card"
              items={payment?.map((defendant) => {
                return {
                  key: String(defendant.idJudgeDef),
                  label: (
                    <>
                      <Space>
                        <Avatar
                          size={24}
                          style={{ background: THEME.gradient, fontSize: 14 }}
                        >
                          {defendant.defendantNumber}
                        </Avatar>
                        {defendant.SNAM}
                        {defendant.NAME1} {defendant.NAME2}{" "}
                        {`(${defendant.defendantNumber === 1 ? "ผู้เช่าซื้อ" : `ผู้ค้ำที่ ${defendant.defendantNumber - 1} `})`}
                      </Space>
                    </>
                  ),
                  children: (
                    <div
                      style={{
                        padding: 0,
                        background: "#ffffff",
                        borderRadius: 16,
                        overflow: "hidden",
                        boxShadow:
                          "0 1px 3px rgba(0,0,0,0.06), 0 6px 16px rgba(0,0,0,0.04)",
                      }}
                    >
                      {/* ── Header Bar ── */}
                      <div
                        style={{
                          background: THEME.gradient,
                          padding: "16px 24px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 16,
                        }}
                      >
                        <Space size={14} align="center">
                          <Avatar
                            size={50}
                            style={{
                              background: "rgba(255,255,255,0.25)",
                              color: "#fff",
                              fontSize: 20,
                              fontWeight: 700,
                              border: "2px solid rgba(255,255,255,0.4)",
                            }}
                          >
                            {defendant.defendantNumber}
                          </Avatar>
                          <div>
                            <Text
                              strong
                              style={{ fontSize: 17, color: "#fff" }}
                            >
                              {defendant.SNAM}
                              {defendant.NAME1} {defendant.NAME2}
                            </Text>
                            <br />
                            <Tag
                              style={{
                                marginTop: 4,
                                borderRadius: 4,
                                padding: "1px 10px",
                                border: "1px solid rgba(255,255,255,0.4)",
                                background: "rgba(255,255,255,0.2)",
                                color: "#fff",
                                fontSize: 12,
                              }}
                            >
                              {defendant.defendantNumber === 1
                                ? "ผู้เช่าซื้อ"
                                : `ผู้ค้ำประกันที่ ${defendant.defendantNumber - 1}`}
                            </Tag>
                            <Text
                              style={{
                                fontSize: 13,
                                color: "rgba(255,255,255,0.85)",
                                marginLeft: 8,
                              }}
                            >
                              <IdcardOutlined style={{ marginRight: 4 }} />
                              {defendant.CUSCOD}
                            </Text>
                          </div>
                        </Space>

                        {/* ฝั่งขวา: ยอดปิด + วันที่ */}
                        <Space size={10} wrap>
                          <div
                            style={{
                              background: "rgba(255,255,255,0.95)",
                              borderRadius: 10,
                              padding: "8px 18px",
                              textAlign: "right",
                              minWidth: 140,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 11,
                                color: "#6b7280",
                                letterSpacing: 0.3,
                              }}
                            >
                              ยอดปิดบัญชี
                            </Text>
                            <br />
                            <Text
                              strong
                              style={{ fontSize: 22, color: THEME.success }}
                            >
                              {formatMoney(defendant.closingbalance)}
                            </Text>
                            <Text
                              style={{
                                fontSize: 13,
                                color: "#9ca3af",
                                marginLeft: 2,
                              }}
                            >
                              ฿
                            </Text>
                          </div>
                          <div
                            style={{
                              background: "rgba(255,255,255,0.95)",
                              borderRadius: 10,
                              padding: "8px 18px",
                              textAlign: "right",
                              minWidth: 120,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 11,
                                color: "#6b7280",
                                letterSpacing: 0.3,
                              }}
                            >
                              ใช้ได้ถึงวันที่
                            </Text>
                            <br />
                            <Text
                              strong
                              style={{ fontSize: 17, color: THEME.danger }}
                            >
                              {formatDate(dateLoad)}
                            </Text>
                          </div>
                        </Space>
                      </div>

                      <div style={{ padding: "20px 24px 24px" }}>
                        <div style={{ marginBottom: 50 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              marginBottom: 14,
                            }}
                          >
                            <div
                              style={{
                                width: 4,
                                height: 18,
                                borderRadius: 2,
                                background: THEME.success,
                              }}
                            />
                            <Text
                              strong
                              style={{ fontSize: 15, color: "#374151" }}
                            >
                              เงินต้นคงเหลือ + เบี้ยปรับ ({" "}
                              {formatMoney(
                                Number(defendant?.TONBALANCE) +
                                  Number(defendant.calInterest),
                              )}{" "}
                              บาท)
                            </Text>
                          </div>
                          <Row gutter={[12, 12]}>
                            {[
                              {
                                label: "เงินต้นคงเหลือ",
                                value: formatMoney(defendant?.TONBALANCE),
                                color: THEME.danger,
                                bg: "#f0fdf4",
                                border: "#dcfce7",
                              },
                              {
                                label: "เบี้ยปรับ (ต้น)",
                                value: formatMoney(defendant.calInterest),
                                color: THEME.danger,
                                bg: "#fef2f2",
                                border: "#fecaca",
                              },
                              {
                                label: `เริ่มคิดดอกเบี้ยเมื่อ (${defendant.days} วัน)`,
                                value: formatDate(defendant.MAX_DATE),
                                color: THEME.danger,
                                bg: "#fff7ed",
                                border: "#fed7aa",
                                isDate: true,
                              },
                              {
                                label: "ตัดต้น",
                                value: formatMoney(defendant?.NPAYRES),
                                color: THEME.success,
                                bg: "#f0fdf4",
                                border: "#dcfce7",
                              },
                              {
                                label: "ตัดดอก",
                                value: formatMoney(defendant.VATPRES),
                                color: THEME.success,
                                bg: "#fef2f2",
                                border: "#fecaca",
                              },
                              {
                                label: "จ่ายล่าสุดเมื่อ",
                                value: formatDate(defendant.payDate),
                                color: THEME.success,
                                bg: "#f9fafb",
                                border: "#e5e7eb",
                                isDate: true,
                              },
                            ].map(
                              (
                                { label, value, color, bg, border, isDate },
                                index,
                              ) => (
                                <Col xs={24} sm={12} lg={8} key={`s1-${index}`}>
                                  <div
                                    style={{
                                      background: bg,
                                      border: `1px solid ${border}`,
                                      borderRadius: 10,
                                      padding: "14px 16px",
                                      height: "100%",
                                      transition: "box-shadow 0.2s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.boxShadow =
                                        "0 2px 8px rgba(0,0,0,0.06)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.boxShadow = "none";
                                    }}
                                  >
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        color: "#6b7280",
                                        display: "block",
                                        marginBottom: 4,
                                      }}
                                      title={label}
                                    >
                                      {label}
                                    </Text>
                                    <Text
                                      strong
                                      style={{ color, fontSize: 18 }}
                                    >
                                      {value}
                                      {!isDate && (
                                        <Text
                                          style={{
                                            fontSize: 12,
                                            marginLeft: 4,
                                            fontWeight: "normal",
                                            color: "#9ca3af",
                                          }}
                                        >
                                          บาท
                                        </Text>
                                      )}
                                    </Text>
                                  </div>
                                </Col>
                              ),
                            )}
                          </Row>
                        </div>

                        <div style={{ marginBottom: 50 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              marginBottom: 14,
                            }}
                          >
                            <div
                              style={{
                                width: 4,
                                height: 18,
                                borderRadius: 2,
                                background: THEME.warning,
                              }}
                            />
                            <Text
                              strong
                              style={{ fontSize: 15, color: "#374151" }}
                            >
                              ค่าขาดประโยชน์ + เบี้ยปรับ (
                              {formatMoney(
                                Number(defendant?.LACK_BALANCE) +
                                  Number(defendant.calInterestCost),
                              )}{" "}
                              บาท)
                            </Text>
                          </div>
                          <Row gutter={[12, 12]}>
                            {[
                              {
                                label: "ค่าขาดประโยชน์",
                                value: formatMoney(defendant.LACK_BALANCE),
                                color: THEME.danger,
                                bg: "#f0fdf4",
                                border: "#dcfce7",
                              },
                              {
                                label: "เบี้ยปรับ (ขาดประโยชน์)",
                                value: formatMoney(defendant.calInterestCost),
                                color: THEME.danger,
                                bg: "#fef2f2",
                                border: "#fecaca",
                              },
                              {
                                label: `เริ่มคิดดอกเบี้ยเมื่อ (${defendant.daysCost} วัน)`,
                                value: formatDate(defendant.MAX_DATE_COST),
                                color: THEME.danger,
                                bg: "#fff7ed",
                                border: "#fed7aa",
                                isDate: true,
                              },
                              {
                                label: "ตัดต้น",
                                value: formatMoney(defendant?.LACK_NPAYRES),
                                color: THEME.success,
                                bg: "#f0fdf4",
                                border: "#dcfce7",
                              },
                              {
                                label: "ตัดดอก",
                                value: formatMoney(defendant.LACK_VATPRES),
                                color: THEME.success,
                                bg: "#fef2f2",
                                border: "#fecaca",
                              },
                              {
                                label: "จ่ายล่าสุดเมื่อ",
                                value: formatDate(defendant.payDate),
                                color: THEME.success,
                                bg: "#f9fafb",
                                border: "#e5e7eb",
                                isDate: true,
                              },
                            ].map(
                              (
                                { label, value, color, bg, border, isDate },
                                index,
                              ) => (
                                <Col xs={24} sm={12} lg={8} key={`s2-${index}`}>
                                  <div
                                    style={{
                                      background: bg,
                                      border: `1px solid ${border}`,
                                      borderRadius: 10,
                                      padding: "14px 16px",
                                      height: "100%",
                                      transition: "box-shadow 0.2s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.boxShadow =
                                        "0 2px 8px rgba(0,0,0,0.06)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.boxShadow = "none";
                                    }}
                                  >
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        color: "#6b7280",
                                        display: "block",
                                        marginBottom: 4,
                                      }}
                                      title={label}
                                    >
                                      {label}
                                    </Text>
                                    <Text
                                      strong
                                      style={{ color, fontSize: 18 }}
                                    >
                                      {value}
                                      {!isDate && (
                                        <Text
                                          style={{
                                            fontSize: 12,
                                            marginLeft: 4,
                                            fontWeight: "normal",
                                            color: "#9ca3af",
                                          }}
                                        >
                                          บาท
                                        </Text>
                                      )}
                                    </Text>
                                  </div>
                                </Col>
                              ),
                            )}
                          </Row>
                        </div>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: 14,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                              }}
                            >
                              <div
                                style={{
                                  width: 4,
                                  height: 18,
                                  borderRadius: 2,
                                  background: "#6b7280",
                                }}
                              />
                              <Text
                                strong
                                style={{ fontSize: 15, color: "#374151" }}
                              >
                                ลูกหนี้อื่นๆ ({formatMoney(defendant.AROTHR)}{" "}
                                บาท)
                              </Text>
                            </div>
                          </div>

                          <Row gutter={[12, 12]}>
                            {(arothrData || []).map((item, index) => {
                              const colorMap = {
                                111: {
                                  color: "#0369a1",
                                  bg: "#f0f9ff",
                                  border: "#bae6fd",
                                },
                                222: {
                                  color: "#7c3aed",
                                  bg: "#f5f3ff",
                                  border: "#ddd6fe",
                                },
                                333: {
                                  color: "#b45309",
                                  bg: "#fffbeb",
                                  border: "#fde68a",
                                },
                                444: {
                                  color: THEME.danger,
                                  bg: "#fef2f2",
                                  border: "#fecaca",
                                },
                              };
                              const style = colorMap[item.PAYFOR] || {
                                color: "#6b7280",
                                bg: "#f9fafb",
                                border: "#e5e7eb",
                              };

                              return (
                                <Col
                                  xs={24}
                                  sm={12}
                                  lg={6}
                                  key={item.ARCONT || index}
                                >
                                  <div
                                    style={{
                                      background: style.bg,
                                      border: `1px solid ${style.border}`,
                                      borderRadius: 10,
                                      padding: "14px 16px",
                                      height: "100%",
                                      transition: "box-shadow 0.2s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.boxShadow =
                                        "0 2px 8px rgba(0,0,0,0.06)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.boxShadow = "none";
                                    }}
                                  >
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        color: "#6b7280",
                                        display: "block",
                                        marginBottom: 4,
                                      }}
                                    >
                                      {item.FORDESC}
                                    </Text>
                                    <Text
                                      strong
                                      style={{
                                        color: style.color,
                                        fontSize: 18,
                                      }}
                                    >
                                      {formatMoney(item.PAYAMT)}
                                      <Text
                                        style={{
                                          fontSize: 12,
                                          marginLeft: 4,
                                          fontWeight: "normal",
                                          color: "#9ca3af",
                                        }}
                                      >
                                        บาท
                                      </Text>
                                    </Text>
                                    {item?.SMPAY > 0 && (
                                      <>
                                        <Text
                                          style={{
                                            fontSize: 12,
                                            color: "#6b7280",
                                            display: "block",
                                            marginBottom: 4,
                                          }}
                                        >
                                          จ่ายแล้วเมื่อ {formatDate(item.PAYDT)}
                                        </Text>
                                        <Text
                                          strong
                                          style={{
                                            color:
                                              item.SMPAY >= item.PAYAMT
                                                ? "green"
                                                : "red",
                                            fontSize: 18,
                                          }}
                                        >
                                          {formatMoney(item.SMPAY)}
                                          <Text
                                            style={{
                                              fontSize: 12,
                                              marginLeft: 4,
                                              fontWeight: "normal",
                                              color: "#9ca3af",
                                            }}
                                          >
                                            บาท
                                          </Text>
                                        </Text>
                                      </>
                                    )}
                                  </div>
                                </Col>
                              );
                            })}
                            <Divider />
                          </Row>
                        </div>
                      </div>
                    </div>
                  ),
                };
              })}
            />
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default PreviewPayment;
